export default __webpack_public_path__ + "static/media/blue_bg.ffd05c31.svg";